import { useState } from "react"
import { Container, Box } from "@mui/material"
import { makeStyles } from "makeStyles"
import Icon from "@mdi/react"
import { mdiChevronRight, mdiChevronLeft } from "@mdi/js"
import ItemsCarousel from "react-items-carousel"

import Link from "components/i18n/Link"

import useWindowSize from "@secureo/common/hooks/useWindowSize"

import { Category } from "@secureo/common/typings/Category"

const useStyles = makeStyles()({
	arrowButtonLeft: {
		padding: 5,
		background: "white",
		borderRadius: 5,
		border: "2px solid whitesmoke",
		boxShadow: "2px 2px 5px 0px rgba(0,0,0,0.15)",
		outline: "none",
		"&:hover": {
			background: "whitesmoke",
		},
	},
	arrowButtonRight: {
		padding: 5,
		background: "white",
		borderRadius: 5,
		border: "2px solid whitesmoke",
		boxShadow: "2px 2px 5px 0px rgba(0,0,0,0.15)",
		outline: "none",
		"&:hover": {
			background: "whitesmoke",
		},
	},
	"@media only screen and (max-width: 600px)": {
		arrowButtonRight: {
			display: "none",
		},
		arrowButtonLeft: {
			display: "none",
		},
	},
	arrowdown: {
		width: 0,
		height: 0,
		borderLeft: "10px solid transparent",
		borderRight: "10px solid transparent",
		borderTop: "10px solid #fff",
		margin: "auto",
		marginTop: -1,
		opacity: 0,
	},
	image: {
		paddingTop: 8,
		height: 80,
		maxHeight: 80,
		maxWidth: 120,
		objectFit: "contain",
		margin: "auto",
		// mixBlendMode: "multiply",
		filter: "invert(0)",
		"&:hover": {
			filter: "invert(100%)",
		},
	},
	slide: {
		border: "1px solid grey",
		transition: "0.3s",
		background: "white",
		textAlign: "center",
		"&:hover": {
			background: "#263739",
			"& $image": {
				filter: "invert(1) brightness(200%)",
			},
			"& $arrowdown": {
				opacity: 1,
			},
		},
	},
})

const BrandsSlider = ({ brandCategories }: Props) => {
	const { classes } = useStyles()
	const [activeItemIndex, setActiveItemIndex] = useState(0)
	const chevronWidth = 0
	const { innerWidth } = useWindowSize()

	const isDesktop = innerWidth < 1280
	const isTablet = innerWidth < 600

	const slideCount = !isDesktop ? 6 : isTablet ? 2 : 4

	return (
		<Container>
			<Box pt={5} my={5}>
				<div style={{ color: "#4691CE", textTransform: "uppercase", fontSize: 13 }}>
					<strong>Höchste Qualität</strong>
				</div>
				<Box mb={2} style={{ textTransform: "uppercase" }}>
					<h2 style={{ margin: 0 }}>Unsere Marken</h2>
				</Box>
				<div style={{ padding: `0 ${chevronWidth}px` }}>
					<ItemsCarousel
						requestToChangeActive={setActiveItemIndex}
						activeItemIndex={activeItemIndex}
						numberOfCards={slideCount}
						gutter={10}
						leftChevron={
							<button className={classes.arrowButtonLeft}>
								<Icon path={mdiChevronLeft} color="black" size={1} />
							</button>
						}
						rightChevron={
							<button className={classes.arrowButtonRight}>
								<Icon path={mdiChevronRight} color="black" size={1} />
							</button>
						}
						outsideChevron
						chevronWidth={chevronWidth}
						infiniteLoop={true}
						slidesToScroll={2}
						showSlither={true}
					>
						{brandCategories.map((brandCategory) => {
							const { id, name, slug, iconDark } = brandCategory

							return (
								<Link key={id} href={`/brands/${slug}`}>
									<div style={{ height: 110 }} className={classes.slide}>
										<div className={classes.arrowdown} />
										<img alt={name} src={iconDark} className={classes.image} />
									</div>
								</Link>
							)
						})}
					</ItemsCarousel>
				</div>
			</Box>
		</Container>
	)
}

interface Props {
	brandCategories: Category[]
}

export default BrandsSlider
